<template>
        <el-dialog :title="dialogTitle" :visible.sync="resignationDialogVisible" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false"
        class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="选择离职人员" prop="uid">
                <el-select  placeholder="请选择人员，可输入人员姓名搜索" v-model="formData.uid" :remote-method="getUserList"
                    filterable remote reserve-keyword>
                    <el-option v-for="(userItem, userIndex) in userList" :key="userIndex" :value="userItem.uid" :label="userItem.name"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {GetUserList,} from "@/api";
export default {
    name: "handling_resignation",
    props: {
        resignationDialogVisible: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            dialogTitle: "办理离职",
            formData: {
                uid: ""
            },
            formRules: {
                uid: [
                    {required: true, message: "请选择离职人员"}
                ]
            },
            userList: []
        }
    },
    created() {
        this.getUserList()
        },
    methods: {
        // 获取人员
        getUserList(keyword) {
            GetUserList({ keyword: keyword,need_department_path:1 }).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data || [];
                }
            });
        },

        handleDialogClose() {

            this.$emit('update:resignationDialogVisible', false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.$emit('update:resignationDialogVisible', false)
                    let info = this.userList.find(find => find.uid == this.formData.uid)
                    let user_info = {
                        user_id:info.uid,
                        user_name: info.name,
                        department_path: info.department_path ? info.department_path : '',
                        avatar:info.avatar
                    }
                    this.$emit("selectUser",user_info)
                }
            })

        },

    }
}
</script>
